import { getAuthSession, headers } from '@/helpers';
import { type PhoneNumberValidationRequest } from '@/types/consumer-deposit-application-service';

const mobilePhoneNumberApiUrl = `${import.meta.env.VITE_RESURS_EKS_HOST}/api/consumer_deposit_application_service/phone_number/mobile`;

export const validateMobilePhoneNumber = async (
  countryCode: number,
  phoneNumber: number,
) => putValidateMobilePhoneNumber({ countryCode, phoneNumber });

const putValidateMobilePhoneNumber = async (
  request: PhoneNumberValidationRequest,
) => {
  const { accessToken } = getAuthSession();

  return fetch(`${mobilePhoneNumberApiUrl}/validate`, {
    body: JSON.stringify(request),
    headers: headers(accessToken),
    method: 'PUT',
  }).then(async (response) => {
    if (response.status !== 200) {
      const res = await response.json();

      throw Error(res.message);
    } else {
      return Promise.resolve();
    }
  });
};
